import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorName, { url } from "../base/Variables";
import { LazyAxios, catchError, getToken, handleRequest } from "../base";

const baseUrl = `${url}/api/v1/order`

const initialState = {
    'order_loading': false,
    'order_success': null,
    'order_error': null,
    'order_error_type': null,
    'order_action': null,
    'all_order': null,
    'all_order_page': 1,
    'all_order_last_page': false
}


const getAllOrder = createAsyncThunk('getAllOrder', async (page, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/all/?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        console.log(request.data)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})


const orderSlice = createSlice({
    name: 'orderSlice',
    initialState: initialState,
    reducers: {
        orderSliceDefault(state, action) {
            state.order_loading = false
            state.order_success = null
            state.order_error = null
            state.order_error_type = null
            state.order_action = null
            state.all_order = null
            state.all_order_page = 1
            state.all_order_last_page = false
        },
        orderDefault(state, action) {
            state.order_error = null
            state.order_error_type = null
            state.order_success = null
        },
        // once order placed then reset so that again orders will fetch
        resetAllOrder(state, action) {
            state.all_order = action.payload
            state.order_loading = true

        },
        incAllOrderPage(state, action) {
            state.all_order_page = state.all_order_page + 1
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllOrder.pending, (state) => {
                state.order_loading = true
                state.order_error = null
                state.order_error_type = null
                state.order_success = null
            })
            .addCase(getAllOrder.fulfilled, (state, action) => {
                state.order_loading = false
                state.all_order = state.all_order ? [...state.all_order, ...action.payload.data] : action.payload.data
            })
            .addCase(getAllOrder.rejected, (state, action) => {
                action.payload.error_message === errorName.invalidPage ?
                    state.all_order_last_page = true :
                    state.order_error = action.payload.error_message
                state.order_error_type = action.payload.type
                state.order_loading = false
            })
    }
})

export default orderSlice;
export { getAllOrder }
export const { orderSliceDefault, orderDefault, resetAllOrder, incAllOrderPage } = orderSlice.actions